export const LOCAL_KEY = '@arideweb:auth';
export const LOCAL_USERDATA_KEY = '@arideweb:user';
export const QUOTE_RESPONSE = '@arideweb:QUOTE_RESPONSE';
export const QUOTE_PRODUCTS = '@arideweb:QUOTE_PRODUCTS';
export const CONTRACT_RESPONSE = '@arideweb:CONTRACT_RESPONSE';
